/* Home <-> PDP shared-element transitions via the View Transitions API.
 *
 * Cross-document: both pages opt in with @view-transition { navigation: auto }.
 * This script names the bottle on pageswap / pagereveal so the browser morphs
 * the snapshots. Unsupported browsers just navigate.
 */
(function () {
  'use strict';

  var NAME = 'pdp-bottle';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pendingEl = null;

  var BG_IMAGE = (typeof window.peakLoveBgImages !== 'undefined')
    ? window.peakLoveBgImages
    : {
        annapurna: '/cdn/shop/files/annapurna-bgimg.webp',
        kilimanjaro: '/cdn/shop/files/kilimanjaro-bg.webp',
        huangshan: '/cdn/shop/files/huangshan-bg.webp',
      };

  function pathOf(url) {
    try {
      return new URL(url, location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (err) {
      return '';
    }
  }

  function homePath() {
    var urls = window.peakLovePdpUrls;
    if (urls && urls.home) return pathOf(urls.home);
    return '/';
  }

  function isHomeUrl(url) {
    var path = pathOf(url);
    return path === homePath() || path === '/';
  }

  function productFromUrl(url) {
    var m = pathOf(url).match(/\/products\/([^/]+)$/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function pdpSlot() {
    return document.querySelector('.centered-wrapper');
  }

  function homeSlot(product) {
    if (!product) return null;
    return document.querySelector(
      '.shape-wrapper[data-product="' + product + '"], .shape-wrapper[data-id="' + product + '"]'
    );
  }

  function namedHomeEl(wrapper) {
    if (!wrapper) return null;
    return wrapper.querySelector('.shape-img-stack') || wrapper;
  }

  function setName(el) {
    if (!el) return;
    el.style.setProperty('view-transition-name', NAME);
  }

  function clearName(el) {
    if (!el) return;
    el.style.removeProperty('view-transition-name');
  }

  function skipTransition(vt) {
    if (!vt || typeof vt.skipTransition !== 'function') return;
    try { vt.skipTransition(); } catch (err) { /* ignore */ }
  }

  function addType(vt, type) {
    if (!vt || !vt.types || typeof vt.types.add !== 'function') return;
    try { vt.types.add(type); } catch (err) { /* ignore */ }
  }

  function destUrl(event) {
    if (event.activation && event.activation.entry) return event.activation.entry.url;
    return '';
  }

  function fromUrl() {
    try {
      if (navigation && navigation.activation && navigation.activation.from) {
        return navigation.activation.from.url;
      }
    } catch (err) { /* ignore */ }
    return '';
  }

  function releaseLoadAnimation() {
    window.peakLoveVtReady = true;
    if (typeof window.peakLoveVtOnReady === 'function') {
      window.peakLoveVtOnReady();
      window.peakLoveVtOnReady = null;
    } else if (
      document.querySelector('.centered-wrapper') &&
      typeof window.setCanStartAnimations === 'function' &&
      !(window.animationState && window.animationState.canStart)
    ) {
      window.setCanStartAnimations(true);
    }
  }

  window.addEventListener('pageswap', function (event) {
    var vt = event.viewTransition;
    if (!vt) return;

    if (reduced || (window.Shopify && window.Shopify.designMode)) {
      skipTransition(vt);
      pendingEl = null;
      return;
    }

    var dest = destUrl(event);
    var destProduct = productFromUrl(dest);
    var destIsHome = isHomeUrl(dest);
    var destIsPdp = !!destProduct;

    if (!destIsHome && !destIsPdp) {
      pendingEl = null;
      return;
    }

    var el = pendingEl && document.contains(pendingEl) ? pendingEl : null;

    if (destIsPdp) {
      if (!el) el = namedHomeEl(homeSlot(destProduct)) || pdpSlot();
      addType(vt, pdpSlot() ? 'pdp-to-pdp' : 'home-to-pdp');
    } else {
      if (!el) el = pdpSlot();
      addType(vt, 'pdp-to-home');
    }

    setName(el);
    pendingEl = null;
  });

  window.addEventListener('pagereveal', function (event) {
    var vt = event.viewTransition;
    var bottle = pdpSlot();

    if (!vt) {
      releaseLoadAnimation();
      return;
    }

    if (reduced || (window.Shopify && window.Shopify.designMode)) {
      skipTransition(vt);
      releaseLoadAnimation();
      return;
    }

    var from = fromUrl();
    var fromProduct = productFromUrl(from);
    var named = null;

    if (bottle) {
      named = bottle;
      addType(vt, isHomeUrl(from) ? 'home-to-pdp' : 'pdp-to-pdp');
    } else if (fromProduct) {
      var slot = homeSlot(fromProduct);
      named = namedHomeEl(slot);
      if (slot) {
        var stack = slot.querySelector('.shape-img-stack');
        if (stack) stack.classList.add('in-view');
      }
      addType(vt, 'pdp-to-home');
    }

    setName(named);

    if (bottle && window.PeakLoveProductShader && typeof window.PeakLoveProductShader.paint === 'function') {
      window.PeakLoveProductShader.paint();
    }

    var done = function () {
      clearName(named);
      releaseLoadAnimation();
    };
    if (vt.finished) vt.finished.then(done, done);
    else done();
  });

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var shape = event.target.closest && event.target.closest('a.shape-wrapper[href]');
    if (shape) {
      pendingEl = namedHomeEl(shape);
      return;
    }

    var collapse = event.target.closest && event.target.closest('.collapsewrap a[href]');
    if (collapse) pendingEl = pdpSlot();
  }, true);

  var warmed = {};

  function injectSpeculation(id, spec) {
    var prev = document.getElementById(id);
    if (prev) prev.remove();
    var script = document.createElement('script');
    script.id = id;
    script.type = 'speculationrules';
    script.textContent = JSON.stringify(spec);
    document.head.appendChild(script);
  }

  /* Same eager prerender as before, started after load, the intro and an idle moment instead of alongside them. */
  window.peakLoveSpeculate = function (urls) {
    if (!urls || !urls.length) return;
    if (!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) return;

    function inject() {
      injectSpeculation('peak-love-prerender-eager', {
        prefetch: [{ source: 'list', urls: urls, eagerness: 'immediate' }],
        prerender: [{ source: 'list', urls: urls, eagerness: 'eager' }],
      });
    }

    function schedule() {
      setTimeout(function () {
        if ('requestIdleCallback' in window) requestIdleCallback(inject, { timeout: 4000 });
        else inject();
      }, 2500);
    }

    function afterIntro() {
      if (!document.body.classList.contains('is-preloading')) {
        schedule();
        return;
      }
      var observer = new MutationObserver(function () {
        if (document.body.classList.contains('is-preloading')) return;
        observer.disconnect();
        schedule();
      });
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    if (document.readyState === 'complete') afterIntro();
    else window.addEventListener('load', afterIntro, { once: true });
  };

  function warm(link) {
    var id = link.dataset.product || link.dataset.id || '';
    var href = link.href || link.getAttribute('href');
    if (href) {
      injectSpeculation('peak-love-prerender-hover', {
        prerender: [{ source: 'list', urls: [href], eagerness: 'immediate' }],
      });
    }
    if (warmed[id]) return;
    warmed[id] = true;

    var bg = BG_IMAGE[id];
    if (!bg) return;
    var tag = document.createElement('link');
    tag.rel = 'prefetch';
    tag.as = 'image';
    tag.href = bg;
    document.head.appendChild(tag);
  }

  function initPrefetch() {
    document.querySelectorAll('.product-shapes-wrap .shape-wrapper[href]').forEach(function (link) {
      link.addEventListener('pointerenter', function () { warm(link); });
      link.addEventListener('focus', function () { warm(link); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrefetch);
  } else {
    initPrefetch();
  }
})();
